import React from 'react';

/* eslint-disable max-len */

interface Svg extends React.SVGProps<SVGSVGElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function Svg({
  children, className, viewBox, ...props
}: Svg): React.ReactNode {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      height="1em"
      width="1em"
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
}

Svg.defaultProps = {
  className: '',
  viewBox: '0 0 24 24',
  style: {},
};

export function IconDockToLeft(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask id="mask0_599_9869" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_599_9869)">
        <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" />
      </g>
    </Svg>
  );
}

export function IconDockToRight(props: Partial<Svg>) {
  return (
    <IconDockToLeft {...props} style={{ transform: 'scale(-1, 1)', ...(props?.style || {}) }} />
  );
}

export function TruckIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M23.5331 9.33268H20.0331V4.66602H3.69979C2.41646 4.66602 1.36646 5.71602 1.36646 6.99935V19.8327H3.69979C3.69979 21.7694 5.26312 23.3327 7.19979 23.3327C9.13646 23.3327 10.6998 21.7694 10.6998 19.8327H17.6998C17.6998 21.7694 19.2631 23.3327 21.1998 23.3327C23.1365 23.3327 24.6998 21.7694 24.6998 19.8327H27.0331V13.9993L23.5331 9.33268ZM7.19979 21.5827C6.23146 21.5827 5.44979 20.801 5.44979 19.8327C5.44979 18.8644 6.23146 18.0827 7.19979 18.0827C8.16812 18.0827 8.94979 18.8644 8.94979 19.8327C8.94979 20.801 8.16812 21.5827 7.19979 21.5827ZM22.9498 11.0827L25.2365 13.9993H20.0331V11.0827H22.9498ZM21.1998 21.5827C20.2315 21.5827 19.4498 20.801 19.4498 19.8327C19.4498 18.8644 20.2315 18.0827 21.1998 18.0827C22.1681 18.0827 22.9498 18.8644 22.9498 19.8327C22.9498 20.801 22.1681 21.5827 21.1998 21.5827Z" fill="#339999" />
    </Svg>
  );
}
export function AirIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M25.0998 18.6673V16.334L15.7664 10.5007V4.08398C15.7664 3.11565 14.9848 2.33398 14.0164 2.33398C13.0481 2.33398 12.2664 3.11565 12.2664 4.08398V10.5007L2.93311 16.334V18.6673L12.2664 15.7507V22.1673L9.93311 23.9173V25.6673L14.0164 24.5007L18.0998 25.6673V23.9173L15.7664 22.1673V15.7507L25.0998 18.6673Z" fill="#339999" />
    </Svg>
  );
}
export function SeaIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M23.3333 24.4994C21.7116 24.4994 20.09 23.951 18.6666 22.9594C15.82 24.9544 12.18 24.9544 9.33328 22.9594C7.90995 23.951 6.28828 24.4994 4.66662 24.4994H2.33328V26.8327H4.66662C6.27662 26.8327 7.86328 26.4244 9.33328 25.6777C12.2733 27.1827 15.7266 27.1827 18.6666 25.6777C20.1366 26.436 21.7233 26.8327 23.3333 26.8327H25.6666V24.4994H23.3333ZM4.60828 22.166H4.66662C6.53328 22.166 8.18995 21.1394 9.33328 19.8327C10.4766 21.1394 12.1333 22.166 14 22.166C15.8666 22.166 17.5233 21.1394 18.6666 19.8327C19.8099 21.1394 21.4666 22.166 23.3333 22.166H23.3916L25.5966 14.3727C25.69 14.0693 25.6666 13.7427 25.5266 13.4627C25.3866 13.1827 25.13 12.9727 24.8266 12.8793L23.3333 12.3893V6.99935C23.3333 5.71602 22.2833 4.66602 21 4.66602H17.5V1.16602H10.5V4.66602H6.99995C5.71662 4.66602 4.66662 5.71602 4.66662 6.99935V12.3893L3.16162 12.8793C2.85828 12.9727 2.60162 13.1827 2.46162 13.4627C2.32162 13.7427 2.28662 14.0693 2.39162 14.3727L4.60828 22.166ZM6.99995 6.99935H21V11.631L14 9.33268L6.99995 11.631V6.99935Z" fill="#339999" />
    </Svg>
  );
}
export function RailIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M14.4 2.33398C9.73332 2.33398 5.06665 2.91732 5.06665 7.00065V18.084C5.06665 20.3356 6.89832 22.1673 9.14998 22.1673L7.39998 23.9173V24.5007H10.0017L12.335 22.1673H16.7333L19.0667 24.5007H21.4V23.9173L19.65 22.1673C21.9017 22.1673 23.7333 20.3356 23.7333 18.084V7.00065C23.7333 2.91732 19.5567 2.33398 14.4 2.33398ZM9.14998 19.834C8.18165 19.834 7.39998 19.0523 7.39998 18.084C7.39998 17.1157 8.18165 16.334 9.14998 16.334C10.1183 16.334 10.9 17.1157 10.9 18.084C10.9 19.0523 10.1183 19.834 9.14998 19.834ZM13.2333 11.6673H7.39998V7.00065H13.2333V11.6673ZM15.5667 11.6673V7.00065H21.4V11.6673H15.5667ZM19.65 19.834C18.6817 19.834 17.9 19.0523 17.9 18.084C17.9 17.1157 18.6817 16.334 19.65 16.334C20.6183 16.334 21.4 17.1157 21.4 18.084C21.4 19.0523 20.6183 19.834 19.65 19.834Z" fill="#339999" />
    </Svg>
  );
}
export function CourierIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M14.8 12.4427C17.3822 12.4427 19.4511 10.3583 19.4511 7.77604C19.4511 5.19382 17.3822 3.10938 14.8 3.10938C12.2178 3.10938 10.1334 5.19382 10.1334 7.77604C10.1334 10.3583 12.2178 12.4427 14.8 12.4427ZM14.8 15.5538C11.1756 15.5538 3.91113 17.3738 3.91113 20.9983V24.8872H25.6889V20.9983C25.6889 17.3738 18.4245 15.5538 14.8 15.5538Z" fill="#339999" />
    </Svg>
  );
}
export function DollarIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3328_5277)">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.71 7.58 16.61 7.47 14.67H9.43C9.53 15.72 10.25 16.54 12.08 16.54C14.04 16.54 14.48 15.56 14.48 14.95C14.48 14.12 14.04 13.34 11.81 12.81C9.33 12.21 7.63 11.19 7.63 9.14C7.63 7.42 9.02 6.3 10.74 5.93V4H13.41V5.95C15.27 6.4 16.2 7.81 16.26 9.34H14.3C14.25 8.23 13.66 7.47 12.08 7.47C10.58 7.47 9.68 8.15 9.68 9.11C9.68 9.95 10.33 10.5 12.35 11.02C14.37 11.54 16.53 12.41 16.53 14.93C16.52 16.76 15.15 17.76 13.41 18.09Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3328_5277">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function CompleteIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3328_2880)">
        <path d="M19 1H5C3.9 1 3.01 1.9 3.01 3L3 15.93C3 16.62 3.35 17.23 3.88 17.59L12 23L20.11 17.59C20.64 17.23 20.99 16.62 20.99 15.93L21 3C21 1.9 20.1 1 19 1ZM10 16L5 11L6.41 9.59L10 13.17L17.59 5.58L19 7L10 16Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3328_2880">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function PhoneIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3328_5487)">
        <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3328_5487">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function FileIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3328_6068)">
        <path d="M5.33333 1.33398C4.6 1.33398 4.01333 1.93398 4.01333 2.66732L4 21.334C4 22.0673 4.58667 22.6673 5.33333 22.6673H18.6667C19.4 22.6673 20 22.0673 20 21.334V8.00065L13.3333 1.33398H5.33333ZM13.3333 8.00065V2.66732L18.6667 8.00065H13.3333Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3328_6068">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function FolderIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3328_1879)">
        <path d="M10 4H4C2.895 4 2.01 4.895 2.01 6L2 18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V8C22 6.895 21.105 6 20 6H12L10 4Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3328_1879">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function CalendarIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M17 12H12V17H17V12ZM16 1V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1H16ZM19 19H5V8H19V19Z" fill="#339999" />
    </Svg>
  );
}
export function DirectionIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3368_6662)">
        <path d="M12.6777 4L11.2677 5.41L16.8477 11H4.67773V13H16.8477L11.2677 18.59L12.6777 20L20.6777 12L12.6777 4Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3368_6662">
          <rect width="24" height="24" fill="white" transform="translate(0.677734)" />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function NotFoundIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 13 12">
      <path d="M6.35522 0.75C3.45601 0.75 1.10522 3.10078 1.10522 6C1.10522 8.89922 3.45601 11.25 6.35522 11.25C9.25444 11.25 11.6052 8.89922 11.6052 6C11.6052 3.10078 9.25444 0.75 6.35522 0.75ZM6.35522 10.3594C3.94819 10.3594 1.99585 8.40703 1.99585 6C1.99585 3.59297 3.94819 1.64062 6.35522 1.64062C8.76226 1.64062 10.7146 3.59297 10.7146 6C10.7146 8.40703 8.76226 10.3594 6.35522 10.3594Z" fill="black" fillOpacity="0.88" />
      <path d="M8.40248 7.48358L6.73139 6.27538V3.375C6.73139 3.32344 6.68921 3.28125 6.63764 3.28125H6.07397C6.02241 3.28125 5.98022 3.32344 5.98022 3.375V6.60233C5.98022 6.6328 5.99429 6.66093 6.0189 6.67851L7.95717 8.09178C7.99936 8.12225 8.05795 8.11288 8.08842 8.07186L8.42358 7.61483C8.45405 7.57147 8.44467 7.51288 8.40248 7.48358Z" fill="black" fillOpacity="0.88" />
    </Svg>
  );
}
export function OnTheWayIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 13 12">
      <path d="M2.82376 5.90859C2.83548 5.39648 2.94095 4.89961 3.13899 4.43203C3.34173 3.95156 3.63235 3.52148 4.00267 3.15C4.37298 2.77852 4.80423 2.48789 5.2847 2.28516C5.78157 2.07539 6.30892 1.96875 6.85384 1.96875C7.39876 1.96875 7.9261 2.07539 8.42181 2.28516C8.9009 2.48747 9.33596 2.78123 9.70267 3.15C9.81868 3.26602 9.92767 3.38906 10.0284 3.51797L9.32298 4.06875C9.30902 4.07955 9.29839 4.09407 9.29232 4.11064C9.28625 4.1272 9.28497 4.14515 9.28864 4.16241C9.29232 4.17967 9.30079 4.19555 9.31308 4.20821C9.32537 4.22087 9.34099 4.2298 9.35814 4.23398L11.4171 4.73789C11.4757 4.75195 11.5331 4.70742 11.5331 4.64766L11.5425 2.52773C11.5425 2.44922 11.4523 2.40469 11.3913 2.45391L10.7304 2.9707C9.82923 1.81758 8.42767 1.07812 6.85267 1.07812C4.1679 1.07812 1.98353 3.22969 1.93313 5.90391C1.93282 5.91641 1.93502 5.92886 1.93959 5.9405C1.94416 5.95215 1.95101 5.96276 1.95975 5.97172C1.96849 5.98067 1.97893 5.98779 1.99046 5.99265C2.00199 5.9975 2.01437 6 2.02688 6H2.73001C2.78157 6 2.82259 5.95898 2.82376 5.90859ZM11.6831 6H10.98C10.9284 6 10.8874 6.04102 10.8863 6.09141C10.8745 6.60352 10.7691 7.10039 10.571 7.56797C10.3683 8.04844 10.0777 8.47969 9.70735 8.85C9.33358 9.22532 8.88921 9.52292 8.39986 9.72566C7.91051 9.9284 7.38587 10.0323 6.85618 10.0312C6.32667 10.0322 5.80221 9.92837 5.31306 9.72563C4.8239 9.52288 4.37973 9.22528 4.00618 8.85C3.89017 8.73398 3.78118 8.61094 3.6804 8.48203L4.38587 7.93125C4.39983 7.92045 4.41045 7.90593 4.41653 7.88936C4.4226 7.8728 4.42388 7.85485 4.4202 7.83759C4.41653 7.82033 4.40806 7.80445 4.39577 7.79179C4.38348 7.77913 4.36786 7.7702 4.35071 7.76602L2.29173 7.26211C2.23313 7.24805 2.17571 7.29258 2.17571 7.35234L2.16751 9.47344C2.16751 9.55195 2.25774 9.59648 2.31868 9.54727L2.97962 9.03047C3.88079 10.1824 5.28235 10.9219 6.85735 10.9219C9.54329 10.9219 11.7265 8.76914 11.7769 6.09609C11.7772 6.08359 11.775 6.07114 11.7704 6.0595C11.7659 6.04785 11.759 6.03724 11.7503 6.02828C11.7415 6.01933 11.7311 6.01221 11.7196 6.00735C11.708 6.0025 11.6956 6 11.6831 6Z" fill="#1677FF" />

    </Svg>
  );
}
export function TrackingIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 90 56">
      <rect width="89.3552" height="56" fill="#EBF5F5" />
      <path fillRule="evenodd" clipRule="evenodd" d="M45 15.4951L57.375 21.6098V35.5151L45 41.6299L32.625 35.5151V21.6098L45 15.4951ZM34.875 24.1195V34.1171L43.875 38.5642V28.5665L34.875 24.1195ZM46.125 28.5665V38.5642L55.125 34.1171V24.1195L51.75 25.7872V30.25L49.5 31.375V26.899L46.125 28.5665ZM53.7105 22.3088L50.7791 23.7572C50.7148 23.7042 50.6436 23.6576 50.5659 23.6187L42.1522 19.4119L45 18.0048L53.7105 22.3088ZM39.6218 20.6623L48.2807 24.9917L45 26.6128L36.2896 22.3088L39.6218 20.6623Z" fill="#ADCCCC" />
    </Svg>
  );
}
export function DropdownIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M7.41 8.83984L12 13.4198L16.59 8.83984L18 10.2498L12 16.2498L6 10.2498L7.41 8.83984Z" fill="#339999" />
    </Svg>
  );
}

export function RefreshIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3368_6669)">
        <path d="M18.15 6.35C16.7 4.9 14.71 4 12.5 4C8.08001 4 4.51001 7.58 4.51001 12C4.51001 16.42 8.08001 20 12.5 20C16.23 20 19.34 17.45 20.23 14H18.15C17.33 16.33 15.11 18 12.5 18C9.19001 18 6.50001 15.31 6.50001 12C6.50001 8.69 9.19001 6 12.5 6C14.16 6 15.64 6.69 16.72 7.78L13.5 11H20.5V4L18.15 6.35Z" fill="#339999" />
      </g>
      <defs>
        <clipPath id="clip0_3368_6669">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </Svg>
  );
}

export function TimelineIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="9" fill="white" strokeWidth="2" />
      <circle cx="10" cy="10" r="5" fill="inherit" />
    </Svg>
  );
}

export function ProductIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 25 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4C5.17157 4 4.5 4.67157 4.5 5.5V18.5C4.5 19.3284 5.17157 20 6 20H19C19.8284 20 20.5 19.3284 20.5 18.5V5.5C20.5 4.67157 19.8284 4 19 4H15.5V10H9.5V4H6Z"
        fill="#339999"
      />
      <rect x="11.5" y="4" width="2" height="4" fill="#339999" />
    </Svg>
  );
}

export function PackageIcon(props: Partial<Svg>) {
  return (
    <Svg {...props} viewBox="0 0 24 24">
      <path d="M22 18H2V20H4V22H6V20H11V22H13V20H18V22H20V20H22V18Z" fill="#339999" />
      <path
        d="M9 2H6.5C5.67157 2 5 2.67157 5 3.5V14.5C5 15.3284 5.67157 16 6.5 16H17.5C18.3284 16 19 15.3284 19 14.5V3.5C19 2.67157 18.3284 2 17.5 2H15V7H9V2Z"
        fill="#339999"
      />
      <rect x="11" y="2" width="2" height="3" fill="#339999" />
    </Svg>
  );
}

export function IconDangerousOutlined(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5201 4.33184C12.4571 4.33347 12.3943 4.35533 12.3407 4.39763C12.336 4.40232 12.3307 4.40642 12.3254 4.41052C12.3202 4.41462 12.3149 4.41873 12.3102 4.42341L7.06646 9.66381C7.01706 9.74849 6.95677 9.8266 6.88699 9.89607L4.94168 11.839C4.88711 11.8936 4.85698 11.9618 4.85127 12.0314C4.85753 12.1001 4.88759 12.1672 4.94145 12.2211L12.3125 19.5851C12.3711 19.6437 12.4453 19.6741 12.5201 19.6764C12.5949 19.6741 12.6691 19.6437 12.7276 19.5851L20.0987 12.2211C20.1526 12.1672 20.1826 12.1001 20.1889 12.0314C20.1832 11.9618 20.153 11.8936 20.0985 11.839L18.1532 9.89607C18.0834 9.8266 18.0231 9.74849 17.9737 9.66381L12.73 4.42341C12.7253 4.41873 12.72 4.41463 12.7147 4.41053C12.7095 4.40642 12.7042 4.40232 12.6995 4.39763C12.6458 4.35533 12.5831 4.33347 12.5201 4.33184ZM19.596 15.9512C19.6661 15.9069 19.7317 15.8547 19.7914 15.7953L22.6461 12.9429C22.7638 12.8254 22.8571 12.6857 22.9207 12.532C22.9843 12.3783 23.0169 12.2135 23.0167 12.0471C23.0167 12.0406 23.0167 12.0341 23.0165 12.0276C23.0166 12.0217 23.0167 12.0159 23.0167 12.0101C23.0167 11.8437 22.9837 11.6789 22.9198 11.5253C22.8558 11.3716 22.7621 11.2321 22.644 11.1148L17.3945 5.86929C17.3625 5.82687 17.3271 5.78619 17.2883 5.74763L15.6524 4.1117C15.2188 3.6781 14.4735 2.93279 13.4188 1.88045C13.1702 1.63775 12.8448 1.51763 12.5201 1.5198C12.1953 1.51763 11.8699 1.63775 11.6214 1.88045C10.5667 2.93279 9.82137 3.6781 9.38777 4.1117L7.75184 5.74763C7.71307 5.78619 7.67768 5.82687 7.64567 5.86929L2.39613 11.1148C2.27805 11.2321 2.18433 11.3716 2.12037 11.5253C2.05642 11.6789 2.0235 11.8437 2.0235 12.0101C2.0235 12.0159 2.02354 12.0217 2.02362 12.0275C2.02351 12.0341 2.02345 12.0406 2.02344 12.0471C2.02322 12.2135 2.05584 12.3783 2.11944 12.532C2.18303 12.6857 2.27634 12.8254 2.39402 12.9429L5.24871 15.7953C5.30843 15.8547 5.37404 15.9069 5.44417 15.9512L11.6235 22.1258C11.8614 22.3633 12.1838 22.4966 12.52 22.4966C12.52 22.4966 12.52 22.4966 12.5201 22.4966M19.596 15.9512L13.4167 22.1258C13.1978 22.3442 12.9075 22.4746 12.6007 22.4941C12.5739 22.4958 12.5471 22.4966 12.5202 22.4966M12.5201 14.5456C12.5041 14.5459 12.4881 14.5461 12.4721 14.5461C11.8114 14.5461 11.1777 14.2838 10.7105 13.817C10.2432 13.3503 9.98074 12.7171 9.98074 12.057C9.98074 11.3969 10.2432 10.7638 10.7105 10.297C11.1777 9.83019 11.8114 9.56795 12.4721 9.56795C12.4881 9.56795 12.5041 9.5681 12.5201 9.56841C12.536 9.5681 12.552 9.56795 12.568 9.56795C13.2288 9.56795 13.8625 9.83019 14.3297 10.297C14.7969 10.7638 15.0594 11.3969 15.0594 12.057C15.0594 12.7171 14.7969 13.3503 14.3297 13.817C13.8625 14.2838 13.2288 14.5461 12.568 14.5461C12.552 14.5461 12.536 14.5459 12.5201 14.5456Z"
        fill="#FF4D4F"
      />
    </Svg>
  );
}

export function BurgerIcon(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 29 11" {...props}>
      <path
        d="M27.5013 10.5H1.83464C1.52522 10.5 1.22847 10.3771 1.00968 10.1583C0.790885 9.9395 0.667969 9.64275 0.667969 9.33333C0.667969 9.02391 0.790885 8.72717 1.00968 8.50838C1.22847 8.28958 1.52522 8.16667 1.83464 8.16667H27.5013C27.8107 8.16667 28.1075 8.28958 28.3263 8.50838C28.5451 8.72717 28.668 9.02391 28.668 9.33333C28.668 9.64275 28.5451 9.9395 28.3263 10.1583C28.1075 10.3771 27.8107 10.5 27.5013 10.5ZM27.5013 2.33333H1.83464C1.52522 2.33333 1.22847 2.21042 1.00968 1.99162C0.790885 1.77283 0.667969 1.47609 0.667969 1.16667C0.667969 0.857247 0.790885 0.560501 1.00968 0.341709C1.22847 0.122917 1.52522 0 1.83464 0H27.5013C27.8107 0 28.1075 0.122917 28.3263 0.341709C28.5451 0.560501 28.668 0.857247 28.668 1.16667C28.668 1.47609 28.5451 1.77283 28.3263 1.99162C28.1075 2.21042 27.8107 2.33333 27.5013 2.33333Z"
        fill="#212124"
      />
    </Svg>
  );
}

export function InstagramGreenIcon(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3.24219H8C5.23858 3.24219 3 5.48077 3 8.24219V16.2422C3 19.0036 5.23858 21.2422 8 21.2422H16C18.7614 21.2422 21 19.0036 21 16.2422V8.24219C21 5.48077 18.7614 3.24219 16 3.24219ZM19.25 16.2422C19.2445 18.0348 17.7926 19.4867 16 19.4922H8C6.20735 19.4867 4.75549 18.0348 4.75 16.2422V8.24219C4.75549 6.44954 6.20735 4.99768 8 4.99219H16C17.7926 4.99768 19.2445 6.44954 19.25 8.24219V16.2422ZM16.75 8.49219C17.3023 8.49219 17.75 8.04447 17.75 7.49219C17.75 6.93991 17.3023 6.49219 16.75 6.49219C16.1977 6.49219 15.75 6.93991 15.75 7.49219C15.75 8.04447 16.1977 8.49219 16.75 8.49219ZM12 7.74219C9.51472 7.74219 7.5 9.75691 7.5 12.2422C7.5 14.7275 9.51472 16.7422 12 16.7422C14.4853 16.7422 16.5 14.7275 16.5 12.2422C16.5027 11.0479 16.0294 9.90176 15.1849 9.05727C14.3404 8.21278 13.1943 7.73953 12 7.74219ZM9.25 12.2422C9.25 13.761 10.4812 14.9922 12 14.9922C13.5188 14.9922 14.75 13.761 14.75 12.2422C14.75 10.7234 13.5188 9.49219 12 9.49219C10.4812 9.49219 9.25 10.7234 9.25 12.2422Z"
        fill="url(#paint0_linear_318_721)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_318_721"
          x1="10.9182"
          y1="2.08036"
          x2="15.2898"
          y2="20.5248"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAE8C5" />
          <stop offset="0.53" stopColor="#60BDAB" />
          <stop offset="1" stopColor="#33718B" />
        </linearGradient>
      </defs>
    </Svg>
  );
}

export function LinkedInGreenIcon(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 3.24219C3.67157 3.24219 3 3.91376 3 4.74219V19.7422C3 20.5706 3.67157 21.2422 4.5 21.2422H19.5C20.3284 21.2422 21 20.5706 21 19.7422V4.74219C21 3.91376 20.3284 3.24219 19.5 3.24219H4.5ZM8.52076 7.24491C8.52639 8.20116 7.81061 8.79038 6.96123 8.78616C6.16107 8.78194 5.46357 8.14491 5.46779 7.24632C5.47201 6.40116 6.13998 5.72194 7.00764 5.74163C7.88795 5.76132 8.52639 6.40679 8.52076 7.24491ZM12.2797 10.0039H9.75971H9.7583V18.5638H12.4217V18.3641C12.4217 17.9842 12.4214 17.6042 12.4211 17.2241C12.4203 16.2103 12.4194 15.1954 12.4246 14.1819C12.426 13.9358 12.4372 13.6799 12.5005 13.445C12.7381 12.5675 13.5271 12.0008 14.4074 12.1401C14.9727 12.2286 15.3467 12.5563 15.5042 13.0893C15.6013 13.4225 15.6449 13.7811 15.6491 14.1285C15.6605 15.1761 15.6589 16.2237 15.6573 17.2714C15.6567 17.6412 15.6561 18.0112 15.6561 18.381V18.5624H18.328V18.3571C18.328 17.9051 18.3278 17.4532 18.3275 17.0013C18.327 15.8718 18.3264 14.7423 18.3294 13.6124C18.3308 13.1019 18.276 12.5985 18.1508 12.1049C17.9638 11.3708 17.5771 10.7633 16.9485 10.3246C16.5027 10.0124 16.0133 9.81129 15.4663 9.78879C15.404 9.7862 15.3412 9.78281 15.2781 9.7794C14.9984 9.76428 14.7141 9.74892 14.4467 9.80285C13.6817 9.95613 13.0096 10.3063 12.5019 10.9236C12.4429 10.9944 12.3852 11.0663 12.2991 11.1736L12.2797 11.1979V10.0039ZM5.68164 18.5666H8.33242V10.0095H5.68164V18.5666Z"
        fill="url(#paint0_linear_318_723)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_318_723"
          x1="10.9182"
          y1="2.08036"
          x2="15.2898"
          y2="20.5248"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAE8C5" />
          <stop offset="0.53" stopColor="#60BDAB" />
          <stop offset="1" stopColor="#33718B" />
        </linearGradient>
      </defs>
    </Svg>

  );
}

export default Svg;
